module.exports = __webpack_public_path__ + "19d9a98db5dcfb822ea8f1eaef9a9f81.svg";